import styled from "styled-components";
import {VoucherCardSideFooterBox} from "../../common/footer/voucher-card-side-footer.box";

export const VoucherCardBackFooterBox = styled(VoucherCardSideFooterBox)`
`